const spinAnimation = {
  '@keyframes spin': {
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(360deg)'
    }
  }
};
const pulseAnimation = {
  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1.1)'
    },
    '50%': {
      transform: 'scale(0.6)'
    },
    '100%': {
      transform: 'scale(1.1)'
    }
  }
};
const fadeInOutAnimation = {
  '@keyframes fade-in-out': {
    '0%': {
      opacity: 0.3
    },
    '25%': {
      opacity: 1
    },
    '50%': {
      opacity: 0.3
    },
    '75%': {
      opacity: 1
    },
    '100%': {
      opacity: 0.3
    }
  }
};
const textLoading = {
  '@keyframes text-loading': {
    '0%': {
      opacity: 0.2
    },
    '20%': {
      opacity: 1
    },
    '100%': {
      opacity: 0.2
    }
  }
};
const gearRotate = {
  '@keyframes gear': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(-180deg)'
    }
  }
};
const gearRotateReverse = {
  '@keyframes gear-reverse': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(180deg)'
    }
  }
};
const animations = {
  spin: spinAnimation,
  pulse: pulseAnimation,
  gear: gearRotate,
  textLoading: textLoading,
  fadeInOut: fadeInOutAnimation,
  gearReverse: gearRotateReverse
};
export default animations;